import React, { useState } from "react";
import "./BabyShoot.css";
import {
  FaDraftingCompass,
  FaProjectDiagram,
  FaPlug,
  FaTools,
  FaHome,
  FaCouch,
} from "react-icons/fa";
import happy_baby_playing from "../assets/happy_baby_playing.jpg"
const themes = [
  {
    title: "Nature Nest",
    description: "Surround your baby with leaves, flowers, and a soft woodland vibe.",
    image: "https://images.unsplash.com/photo-1555243896-c709bfa0b564",
  },
  {
    title: "Royal Prince/Princess",
    description: "Golden crowns, velvet cushions, and royal elegance for your little one.",
    image: "https://tse2.mm.bing.net/th/id/OIP.OUr86KMR2F2mIsgXVE2W8QHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    title: "Pastel Dreams",
    description: "Soft pastel clouds and dreamy backgrounds for soothing baby portraits.",
    image: "https://img.freepik.com/premium-photo/cute-baby-sleeping-soft-clouds-cute-baby-images-cute-baby-background-images_1037362-10664.jpg?w=2000",
  },
  {
    title: "Teddy Wonderland",
    description: "A cuddly, cute, teddy bear-filled setup for timeless cuteness.",
    image: "https://balloonexhibit.com/wp-content/uploads/2025/01/Welcome-Baby-Boy-Teddy-Bear-theme-At-Home--scaled.webp",
  },
];

const packages = [
  {
    name: "Basic",
    price: "₹4,999",
    features: ["📸 10 edited photos", "👗 1 outfit change", "🖼️ Digital copy only"],
    color: "#ecfdf5",
  },
  {
    name: "Premium",
    price: "₹9,999",
    features: ["📸 25 edited photos", "👗 2 outfit changes", "🖼️ 1 framed print", "🌿 Theme-based setup"],
    color: "#fff7ed",
  },
  {
    name: "Royal",
    price: "₹14,999",
    features: ["📸 40 edited photos", "👗 3 outfit changes", "🖼️ 2 framed prints", "🎥 BTS video", "🌟 Personalized props"],
    color: "#fef2f2",
  },
];

const galleryImages = [
  {
    url: "https://www.sophiecrewphotography.com/wp-content/uploads/2022/09/When-to-hold-newborn-photography-session.jpg",
    theme: "Newborn",
  },
  {
    url: "https://tse3.mm.bing.net/th/id/OIP.m-0eQf4aElN_pccsCxAbNAHaFj?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    theme: "Twins",
  },
  {
    url: "https://i.pinimg.com/originals/64/85/8f/64858f7440222c0e76d03230e6aad015.jpg",
    theme: "Cake Smash",
  },
  {
    url: "https://tse4.mm.bing.net/th/id/OIP.2NTSiWAA2Ng3zCeLl2hTiQHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    theme: "First Festival",
  },
  {
    url: "https://www.bookeventz.com/blog/wp-content/uploads/2018/11/basanet.jpg",
    theme: "Naming Ceremony",
  },
  {
    url: "https://tse4.mm.bing.net/th/id/OIP.cUovxAn9oOH2PMeLeqvRjgHaFj?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    theme: "Baby Functions",
  },
];


const BabyStudioPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div>
      {/* Themes */}
      <div className="baby-themes">
        <h1>Explore Our Baby Shoot Themes</h1>
        <div className="theme-grid">
          {themes.map((t, i) => (
            <div key={i} className="theme-card">
              <img src={t.image} alt={t.title} />
              <h3>{t.title}</h3>
              <p>{t.description}</p>
              <button className="book-btn">Book Now</button>
            </div>
          ))}
        </div>
      </div>

      {/* Packages */}
      <div className="packages-section">
        <h1>💸 Choose Your Perfect Package</h1>
        <div className="packages-grid">
          {packages.map((pkg, i) => (
            <div key={i} className="package-card" style={{ backgroundColor: pkg.color }}>
              <h2>{pkg.name}</h2>
              <p className="price">{pkg.price}</p>
              <ul>
                {pkg.features.map((f, j) => (
                  <li key={j}>{f}</li>
                ))}
              </ul>
              <button className="book-btn">Book Now</button>
            </div>
          ))}
        </div>
      </div>

      {/* Gallery */}
      <div className="gallery-section">
        <h1 className="gallery-heading">Our Baby Gallery</h1>
        <div className="gallery-grid">
          {galleryImages.map((img, i) => (
            <div key={i} className="gallery-item" onClick={() => setSelectedImage(img.url)}>
              <img src={img.url} alt={img.theme} />
              <span className="theme-tag">{img.theme}</span>
            </div>
          ))}
        </div>
        {selectedImage && (
          <div className="lightbox" onClick={() => setSelectedImage(null)}>
            <img src={selectedImage} alt="Enlarged Baby" />
          </div>
        )}
      </div>

      {/* Studio Info */}
      <div className="studio-wrapper">
        <div className="studio-hero">
          <h1>Our Serene Studio Space</h1>
          <p>Designed with nature in mind, our eco-friendly studio keeps your little one calm, cozy, and happy.</p>
        </div>
        <section className="studio-grid">
          <div className="studio-text">
            <h2>Eco-Friendly Design</h2>
            <p>🌿 We use organic cotton fabrics, sustainable wood props, and non-toxic materials throughout the studio. Natural light streams through skylights, and acoustic soundproofing ensures a calm, quiet environment.</p>
          </div>
          <div className="studio-image">
            <img src={happy_baby_playing} alt="Studio Interior" />
          </div>
        </section>
        <div className="studio-video">
          <h2>🎥 Virtual Studio Tour</h2>
         <iframe
  width="560"
  height="315"
  src="https://www.youtube.com/embed/UobfNgFLOqk"
  title="Studio Virtual Tour"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
></iframe>

        </div>
        <div className="safety-section">
          <h2>🧼 Safety & Cleanliness</h2>
          <div className="safety-grid">
            {[
              { img: "https://cdn-icons-png.flaticon.com/512/1046/1046857.png", title: "Sanitized Props", text: "All materials are sterilized before each session." },
              { img: "https://cdn-icons-png.flaticon.com/512/706/706164.png", title: "Air Purifier", text: "HEPA filters ensure a clean indoor environment." },
              { img: "https://cdn-icons-png.flaticon.com/512/2913/2913603.png", title: "Natural Cleaning", text: "We only use organic, baby-safe cleaning products." },
            ].map((card, i) => (
              <div key={i} className="safety-card">
                <img src={card.img} alt={card.title} />
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BabyStudioPage;
